"use client";
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Typography,
  Box,
  Tabs,
  Tab,
  Button,
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StoreInfo from "./StoreInfo";
import SubscriptionTypeClean from "./SubscriptionTypeClean";
import ChatbotSettings from "./ChatbotSetting";
import BrandingAppearance from "./BrandingAppearance";
import ManageSeatsModal from "./ManageSeatsModal";
import ManageLocationsModal from "./ManageLocationsModal";
import PlanChangeModal from "./PlanChangeModal";
import AddLocationDetailsModal from "./AddLocationDetailsModal";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../../../config";

import AcceptJsCardModal from "./AcceptJsCardModal";
import TokenPurchaseModal from "./TokenPurchaseModal";

function CustomTabPanel({ children, value, index }) {
  return value === index ? <Box sx={{ p: 3 }}>{children}</Box> : null;
}

const EditStore = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [tokenPlans, setTokenPlans] = useState([]);
  const CLIENT_ID = config.clientId;
  const [subTab, setSubTab] = useState(0);
  const [selectedTokenPack, setSelectedTokenPack] = useState(null);


  // Loading states
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  // Store Info States
  const [storeName, setStoreName] = useState("");
  const [storeTypes, setStoreTypes] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);
  const [numLocations, setNumLocations] = useState(1);
  const [contactName, setContactName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [storeUrl, setStoreUrl] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [existingPlan, setExistingPlan] = useState("");
  const [cardInfo, setCardInfo] = useState(null);

  const [planAmount, setPlanAmount] = useState(0);
  const [subscriptionStatus, setSubscriptionStatus] = useState("");
  const [nextDueDate, setNextDueDate] = useState(null);


  const [selectedPlan, setSelectedPlan] = useState(existingPlan);
  const [previousPlan, setPreviousPlan] = useState(existingPlan);

  const [plansData, setPlansData] = useState(null);
  const [currentPlanData, setCurrentPlanData] = useState(null);

  // Credit States
  const [subscriptionCreditsGranted, setSubscriptionCreditsGranted] = useState(0);
  const [subscriptionCreditsConsumed, setSubscriptionCreditsConsumed] = useState(0);
  const [topupCreditsGranted, setTopupCreditsGranted] = useState(0);
  const [topupCreditsConsumed, setTopupCreditsConsumed] = useState(0);

  // Modal States
  const [showManageSeatsModal, setShowManageSeatsModal] = useState(false);
  const [showManageLocationsModal, setShowManageLocationsModal] = useState(false);
  const [showPlanChangeModal, setShowPlanChangeModal] = useState(false);
  const [showAddLocationModal, setShowAddLocationModal] = useState(false);
  const [pendingQuantity, setPendingQuantity] = useState(null);
  const [pendingPlan, setPendingPlan] = useState(null);


  // Token Purchase States
  const [showTokenPurchaseModal, setShowTokenPurchaseModal] = useState(false);
  const [isTokenProcessing, setIsTokenProcessing] = useState(false);
  const [tokenSuccess, setTokenSuccess] = useState(false);
  const [tokenError, setTokenError] = useState(null);
  const [tokenCreditsGranted, setTokenCreditsGranted] = useState(0);
  const [tokenPurchaseInvoiceUrl, setTokenPurchaseInvoiceUrl] = useState(null);

  // Upgrade Flow Real-time States
  const [isPlanChangeProcessing, setIsPlanChangeProcessing] = useState(false);
  const [isPlanChangeSuccess, setIsPlanChangeSuccess] = useState(false);
  const [planChangeInvoiceUrl, setPlanChangeInvoiceUrl] = useState(null);
  const [planChangeError, setPlanChangeError] = useState(null);
  const [planChangeMessage, setPlanChangeMessage] = useState(null);
  const [planChangeAmount, setPlanChangeAmount] = useState(0);




  // Chatbot States
  const [chatbotName, setChatbotName] = useState("");
  const [chatbotWelcomeMessage, setChatbotWelcomeMessage] = useState("");
  const [chatbotDisclaimer, setChatbotDisclaimer] = useState("");
  const [chatbotChanged, setChatbotChanged] = useState(false);

  // Branding States
  const [brandingThemeColor, setBrandingThemeColor] = useState("#000000");
  const [brandingFontStyle, setBrandingFontStyle] = useState("");
  const [brandingLogoUrl, setBrandingLogoUrl] = useState("");
  const [brandingChanged, setBrandingChanged] = useState(false);

  const [storeInfoChanged, setStoreInfoChanged] = useState(false);
  const [unpaidInvoice, setUnpaidInvoice] = useState(null);

  const [isActiveStore, setIsActiveStore] = useState(true);
  const [gatewayStatus, setGatewayStatus] = useState(null);

  // Resume Activation States
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [isResuming, setIsResuming] = useState(false);
  const [resumeMessage, setResumeMessage] = useState(null);
  const [resumeError, setResumeError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [resumeInvoiceUrl, setResumeInvoiceUrl] = useState(null);

  // Recovery State for Interrupted Plan Changes
  const [hasInterruptedPlanChange, setHasInterruptedPlanChange] = useState(false);
  const [interruptedTargetPlan, setInterruptedTargetPlan] = useState(null);
  const [interruptedType, setInterruptedType] = useState(null);
  const [isResumingPlan, setIsResumingPlan] = useState(false);
  const [cancelAtPeriodEnd, setCancelAtPeriodEnd] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);

  // Check if plan allows chatbot/branding editing
  const isPremiumOrAbove = ["Premium", "Pro"].includes(selectedPlan);

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };




  // ------------------------------------------------------
  // TOKEN PURCHASE: CORE WORKFLOW
  // ------------------------------------------------------
  const handleTokenPurchase = () => {
    if (!selectedTokenPack) {
      showSnackbar("Please select a token pack", "warning");
      return;
    }

    // Open confirmation modal
    setTokenSuccess(false);
    setTokenError(null);
    setTokenPurchaseInvoiceUrl(null);
    setIsTokenProcessing(false);
    setShowTokenPurchaseModal(true);
  };

  const handleConfirmTokenPurchase = async () => {
    try {
      setIsTokenProcessing(true);
      setTokenError(null);

      const res = await fetch(
        `${config.API_BASE_V2_URL}/tokens/purchase`,
        {
          method: "POST",
          headers: config.getHeaders(),
          body: JSON.stringify({
            store_id: store_id,
            plan_code: selectedTokenPack.plan_code,
          }),
        }
      );

      const json = await res.json();

      if (json.success) {
        setTokenSuccess(true);
        setTokenCreditsGranted(json.credits_granted);
        setTokenPurchaseInvoiceUrl(json.invoice_url);
        showSnackbar("Tokens purchased successfully!", "success");
        // Refresh store data to update credits display
        await fetchStoreData();
      } else {
        setTokenError(json.error || json.detail || "Token purchase failed");
      }
    } catch (err) {
      console.error("Token purchase error:", err);
      setTokenError("Connectivity error. Please try again.");
    } finally {
      setIsTokenProcessing(false);
    }
  };

  // Handle pending invoice payment
  const handlePayPendingInvoice = async () => {
    if (!subscriptionId || !store_id) {
      showSnackbar("Missing subscription or store information", "error");
      return;
    }

    try {
      setLoading(true);
      showSnackbar("Processing payment...", "info");

      // First, fetch subscription to get invoice_id
      const subRes = await fetch(
        `${config.API_BASE_V2_URL}/subscriptions/${subscriptionId}`
      );
      const subData = await subRes.json();

      if (!subData.success || !subData.data) {
        showSnackbar("Failed to fetch subscription details", "error");
        return;
      }

      const invoiceId = subData.data.invoice_id;

      // Call temporary endpoint to mark invoice as paid and grant credits
      const res = await fetch(
        `${config.API_BASE_V2_URL}/invoices/payment/mark-pending-payment-success`,
        {
          method: "POST",
          headers: config.getHeaders(),
          body: JSON.stringify({
            subscription_id: subscriptionId,
            invoice_id: invoiceId,
          }),
        }
      );

      const json = await res.json();

      if (json.success) {
        showSnackbar("Payment completed successfully! Credits have been granted.", "success");
        // Refresh store data to show updated credits and subscription status
        await fetchStoreData();
        setUnpaidInvoice(null);
      } else {
        showSnackbar(json.error || "Failed to process payment", "error");
      }
    } catch (err) {
      console.error("Error processing pending payment:", err);
      showSnackbar("Payment processing failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchTokenPlans = React.useCallback(async () => {
    try {
      const res = await fetch(
        `${config.API_BASE_V2_URL}/invoices/token-plans`
      );
      const json = await res.json();

      if (json.success) {
        setTokenPlans(json.plans);
      }
    } catch (err) {
      console.error("Failed to load token plans:", err);
    }
  }, []);

  // Fetch unpaid invoices for subscription
  const fetchUnpaidInvoices = React.useCallback(async () => {
    if (!subscriptionId) return;
    try {
      // Fetch subscription details
      const res = await fetch(
        `${config.API_BASE_V2_URL}/subscriptions/${subscriptionId}`
      );
      const json = await res.json();

      if (json.success && json.data) {
        
        // 1. Interrupted Plan Change Recovery
        if (json.data.has_interrupted_plan_change !== undefined) {
          setHasInterruptedPlanChange(json.data.has_interrupted_plan_change);
          setInterruptedTargetPlan(json.data.interrupted_target_plan);
          setInterruptedType(json.data.interrupted_type);
        }

        // 2. Unpaid Invoice Detection
        // Check if subscription is pending (unpaid)
        if (json.data.subscription_status === 'pending') {
          // Get checkout_url directly from subscription response (from Sidglo)
          const checkoutUrl = json.data.checkout_url;

          if (checkoutUrl) {
            // Store checkout_url for payment
            const unpaidInvoiceData = {
              checkout_url: checkoutUrl,
              amount: json.data.plan_amount,
              description: `${json.data.plan_name} Plan - ${json.data.billing_cycle}`
            };
            console.log('[EditStore] Checkout URL from subscription:', unpaidInvoiceData);
            setUnpaidInvoice(unpaidInvoiceData);
          }
        }
      }
    } catch (err) {
      console.error("Failed to fetch unpaid invoices:", err);
    }
  }, [subscriptionId]);

  // ------------------------------------------------------
  // STORE INFO SAVE
  // ------------------------------------------------------
  const handleSaveStoreInfo = async () => {
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(contactEmail.trim())) {
        showSnackbar("Please enter a valid email address", "error");
        return;
      }

      const payload = {
        client_id: CLIENT_ID,
        section: "store_info",
        data: {
          store_name: storeName.trim(),
          store_types: storeTypes,
          number_of_locations: numLocations.toString(),
          location_zip_codes: zipCodes,
          contact_person_name: contactName.trim(),
          contact_email_id: contactEmail.trim(),
          domain_url: storeUrl.trim(),
        },
      };

      const res = await fetch(
        `${config.API_BASE_URL}/client/store/${store_id}`,
        {
          method: "PATCH",
          headers: config.getHeaders(),
          body: JSON.stringify(payload),
        }
      );

      const json = await res.json();

      if (!json.success) {
        throw new Error(json.message || "Failed to update store info");
      }

      setStoreInfoChanged(false);
      showSnackbar("Store info updated successfully", "success");
    } catch (error) {
      console.error("Error updating store info:", error);
      showSnackbar(error.message || "Failed to update store info", "error");
    }
  };

  // ------------------------------------------------------
  // CHATBOT SETTINGS SAVE
  // ------------------------------------------------------
  const handleSaveChatbot = async () => {
    try {
      const payload = {
        client_id: CLIENT_ID,
        section: "chatbot",
        data: {
          chatbot_name: chatbotName.trim(),
          chatbot_welcome_message: chatbotWelcomeMessage.trim(),
          chatbot_disclaimer: chatbotDisclaimer.trim(),
          chatbot_logo_url: brandingLogoUrl,
        },
      };

      const res = await fetch(
        `${config.API_BASE_URL}/client/store/${store_id}`,
        {
          method: "PATCH",
          headers: config.getHeaders(),
          body: JSON.stringify(payload),
        }
      );

      const json = await res.json();

      if (!json.success) {
        throw new Error(json.message || "Failed to update chatbot settings");
      }

      setChatbotChanged(false);
      showSnackbar("Chatbot settings updated successfully", "success");
    } catch (error) {
      console.error("Error updating chatbot settings:", error);
      showSnackbar(error.message || "Failed to update chatbot settings", "error");
    }
  };

  // ------------------------------------------------------
  // BRANDING SAVE
  // ------------------------------------------------------
  const handleSaveBranding = async () => {
    try {
      const payload = {
        client_id: CLIENT_ID,
        section: "branding",
        data: {
          theme_color_hex: brandingThemeColor.trim(),
          font_style: brandingFontStyle.trim(),
          logo_url: brandingLogoUrl.trim(),
        },
      };

      const res = await fetch(
        `${config.API_BASE_URL}/client/store/${store_id}`,
        {
          method: "PATCH",
          headers: config.getHeaders(),
          body: JSON.stringify(payload),
        }
      );

      const json = await res.json();

      if (!json.success) {
        throw new Error(json.message || "Failed to update branding");
      }

      setBrandingChanged(false);
      showSnackbar("Branding updated successfully", "success");
    } catch (error) {
      console.error("Error updating branding:", error);
      showSnackbar(error.message || "Failed to update branding", "error");
    }
  };

  // ------------------------------------------------------
  // RESUME INTERRUPTED PLAN CHANGE
  // ------------------------------------------------------
  const handleResumePlanChange = async () => {
    setIsResumingPlan(true);
    try {
      showSnackbar("Resuming your plan transition...", "info");
      
      const res = await fetch(`${config.API_BASE_V2_URL}/subscriptions/resume-plan-change`, {
        method: "POST",
        headers: config.getHeaders(),
        body: JSON.stringify({
          store_id: store_id,
          subscription_id: subscriptionId
        })
      });
      const json = await res.json();
      
      if (!json.success) {
        throw new Error(json.error || json.detail || "Failed to resume plan change.");
      }
      
      showSnackbar("Plan transitioned successfully!", "success");
      setHasInterruptedPlanChange(false);
      setInterruptedTargetPlan(null);
      setInterruptedType(null);
      // Let it refresh everything.
      await fetchStoreData();
      
    } catch (err) {
      console.error(err);
      showSnackbar(err.message, "error");
    } finally {
      setIsResumingPlan(false);
    }
  };

  // ------------------------------------------------------
  // PLAN SELECTION + MODAL
  // ------------------------------------------------------
  const handlePlanSelect = (planObj) => {
    // backup current plan so we can revert on cancel
    setPreviousPlan(selectedPlan);
    setSelectedPlan(planObj.plan_name);

    if (planObj.plan_name !== existingPlan) {
      // Reset upgrade states for a new start
      setIsPlanChangeProcessing(false);
      setIsPlanChangeSuccess(false);
      setPlanChangeInvoiceUrl(null);
      setPlanChangeError(null);
      setPlanChangeMessage(null);
      setPlanChangeAmount(0);


      setPendingPlan(planObj);
      setShowPlanChangeModal(true);
    }
  };

  // ------------------------------------------------------
  // PRORATION CONFIRM → TRIGGER UPGRADE
  // (uses Option B proration format)
  // ------------------------------------------------------
  /**
   * Handles plan change confirmation from modal
   * Modal shows all details, user confirms, then redirects to PaymentWaitingPage
   * (Same pattern as CreateStore)
   */
  const handleProrationConfirm = async (newPlan, prorationData) => {
    try {
      setIsPlanChangeProcessing(true);
      setPlanChangeError(null);
      setPlanChangeMessage("Initializing plan change...");

      const prorationDataCash = prorationData?.cash || {};
      const prorationAmt = Number(prorationDataCash.cash_delta || 0);
      const direction = prorationDataCash.direction || 'upgrade';
      const isUpgradeFlow = direction === 'upgrade';


      const payload = {
        store_id: store_id,
        subscription_id: subscriptionId,
        new_plan_id: newPlan.plan_id,
        proration_amount: prorationAmt,
      };

      setPlanChangeMessage(isUpgradeFlow ? "Processing payment and upgrading subscription..." : "Adjusting plan and updating billing...");

      // Fix 4: 90-second timeout guard.
      // PDF generation + DO Spaces upload can be slow. On timeout we check the real DB state
      // rather than showing an ambiguous error — the backend continues running regardless.
      const abortController = new AbortController();
      const timeoutId = setTimeout(() => abortController.abort(), 90000);

      let response;
      try {
        response = await fetch(
          `${config.API_BASE_V2_URL}/subscriptions/plan-change`,
          {
            method: "POST",
            headers: config.getHeaders(),
            body: JSON.stringify(payload),
            signal: abortController.signal,
          }
        );
      } catch (fetchErr) {
        clearTimeout(timeoutId);
        if (fetchErr.name === "AbortError") {
          // Backend is still running. Check real DB state before saying anything.
          setPlanChangeMessage("Verifying your transaction status...");
          try {
            await fetchStoreData();
            // fetchStoreData updates all state. Possible outcomes:
            // 1. Plan changed + subscription_active → upgrade fully completed. Show a success snackbar.
            // 2. gateway_status = upgrade_charge_succeeded_subscription_failed → resume modal auto-opens.
            // 3. Plan unchanged → charge didn't happen, user can retry (nothing broken).
            // In all cases, close PlanChangeModal — the correct UI surfaces on its own.
            showSnackbar("Your upgrade was processed. Please check your dashboard for the updated plan.", "success");
            setShowPlanChangeModal(false);
          } catch {
            setPlanChangeError(
              "We could not verify your transaction status. Please refresh the page to check if your plan was updated."
            );
            setIsPlanChangeProcessing(false);
          }
          return;
        }
        throw fetchErr;
      }
      clearTimeout(timeoutId);

      const json = await response.json();

      if (!json.success) {
        setPlanChangeError(json.error || `Failed to initiate ${direction}. Please try again.`);
        setIsPlanChangeProcessing(false);
        return;
      }

      // 1. Success Path: Authorize.Net Automatic Flow (Already Settled)
      if (json.flow === 'authorize_net_automatic' || (!json.payment_link && json.success)) {

        // Fix 1c: If the gateway_status signals ARB failure, do NOT show the success screen.
        // Instead close PlanChangeModal so fetchStoreData() naturally opens the resume modal
        // with the "Payment Received, click to retry" recovery view. This avoids dual-modal stacking.
        if (json.gateway_status === 'upgrade_charge_succeeded_subscription_failed') {
          setShowPlanChangeModal(false);
          await fetchStoreData(); // will detect bad gateway_status and auto-open resume modal
          return;
        }

        // Normal success: payment + ARB both succeeded
        setIsPlanChangeSuccess(true);
        setPlanChangeInvoiceUrl(json.invoice_url);
        setPlanChangeAmount(json.proration_amount || 0);
        setPlanChangeMessage(json.message || "Plan update successful!");


        // Refresh session data in background
        await fetchStoreData();
        return;
      }


      // 2. Manual Path: Redirect to payment page (for non-vaulted or legacy flows)
      if (json.payment_link && json.subscription_id && json.invoice_id) {
        setShowPlanChangeModal(false); // Close modal for redirection
        showSnackbar("Redirecting to payment...", "info");

        setTimeout(() => {
          navigate(`/payment-waiting/${json.subscription_id}/${json.invoice_id}`, {
            state: {
              checkoutUrl: json.payment_link,
              isPlanChange: true,
              oldSubscriptionId: json.old_subscription_id,
              isUpgrade: json.is_upgrade,
              isDowngrade: json.is_downgrade,
              prorationCents: json.proration_cents,
              chargeAmountCents: json.charge_amount_cents,
              planAmountCents: json.plan_amount_cents,
            }
          });
        }, 500);
      } else {
        setPlanChangeError(json.message || "Could not retrieve payment details.");
        setIsPlanChangeProcessing(false);
      }
    } catch (error) {
      console.error("Upgrade error:", error);
      // Network drop or unexpected error. The backend may have completed.
      // Try to check the actual store state before showing any error.
      try {
        setPlanChangeMessage("Checking your account status...");
        await fetchStoreData();
        // If fetchStoreData succeeds, the correct state is now loaded.
        // If plan changed → dashboard shows it. If ARB failed → resume modal opens.
        showSnackbar("Please check your dashboard for the latest plan status.", "info");
        setShowPlanChangeModal(false);
      } catch {
        // Truly no connectivity — can't check anything
        setPlanChangeError(
          "Connection was interrupted during your upgrade. Please refresh the page once your connection is restored to check your plan status."
        );
        setIsPlanChangeProcessing(false);
      }
    } finally {
      setIsPlanChangeProcessing(false);
    }
  };

  // ------------------------------------------------------
  // DATA FETCHING
  // ------------------------------------------------------

  const fetchPlansData = React.useCallback(async () => {
    try {
      const response = await fetch(
        `${config.API_BASE_V2_URL}/subscriptions/plans`, {
        headers: config.getHeaders()
      }
      );
      const result = await response.json();

      if (result.success && result.data) {
        // Filter and sort plans in order: Basic, Pro, Premium
        const order = ["Basic", "Pro", "Premium", "Demo"];
        const sorted = result.data
          .filter(plan => order.includes(plan.plan_name))
          .sort((a, b) => {
            return order.indexOf(a.plan_name) - order.indexOf(b.plan_name);
          });
        setPlansData(sorted);
      }
    } catch (err) {
      console.error(err);
      showSnackbar("Failed to load plans", "error");
    }
  }, []);

  const fetchStoreData = React.useCallback(async () => {
    try {
      setLoading(true);
      const url = `${config.API_BASE_URL}/client/store/${store_id}?client_id=${CLIENT_ID}`;
      const res = await fetch(url, { headers: config.getHeaders() });
      const json = await res.json();

      if (!json.success) throw new Error(json.message);

      const data = json.data;
      setStoreName(data.store_name || "");
      setStoreTypes(data.store_types || []);
      setZipCodes(data.location_zip_codes || []);
      setNumLocations(+data.number_of_locations || 1);
      setContactName(data.contact_person_name || "");
      setContactEmail(data.contact_email_id || "");
      setStoreUrl(data.domain_url || "");


      setSubscriptionId(data.subscription_id);
      setSelectedPlan(data.plan_name);
      setPreviousPlan(data.plan_name);
      setExistingPlan(data.plan_name);
      setPlanAmount(data.plan_amount);
      // setBillingCycle(data.billing_cycle); 
      setSubscriptionStatus(data.subscription_status || "");
      setNextDueDate(data.next_due_date || null);
      setCardInfo(data.card_info || null);

      // Credits
      setSubscriptionCreditsGranted(data.subscription_credits_granted || 0);
      setSubscriptionCreditsConsumed(data.subscription_credits_consumed || 0);
      setTopupCreditsGranted(data.topup_credits_granted || 0);
      setTopupCreditsConsumed(data.topup_credits_consumed || 0);

      const current = plansData?.find(
        (p) => p.plan_name === data.plan_name
      );
      setCurrentPlanData(current || null);

      // Chatbot
      setChatbotName(data.chatbot_name || "");
      setChatbotWelcomeMessage(data.chatbot_welcome_message || "");
      setChatbotDisclaimer(data.chatbot_disclaimer || "");

      // Branding
      setBrandingLogoUrl(data.chatbot_logo_url || "");

      // ✅ STATE GUARDRAIL: Identify if this store is fully active
      // Store is active only if it's 'active'/'trialing' AND gateway_status is 'subscription_active'
      const isSubscribed = data.gateway_status === 'subscription_active';
      const isActuallyActive = (data.subscription_status === 'active' || data.subscription_status === 'trialing') && isSubscribed;

      setIsActiveStore(isActuallyActive);
      setGatewayStatus(data.gateway_status);
      setCancelAtPeriodEnd(data.cancel_at_period_end || false);

      // Auto-open resume modal if not subscribed
      if (!isSubscribed) {
        setShowResumeModal(true);
      }

    } catch (err) {
      console.error(err);
      showSnackbar(err.message, "error");
    } finally {
      setLoading(false);
    }
  }, [store_id, CLIENT_ID, plansData]);

  useEffect(() => {
    fetchPlansData();
  }, [fetchPlansData]);

  useEffect(() => {
    if (plansData) fetchStoreData();
  }, [plansData, fetchStoreData]);

  useEffect(() => {
    fetchTokenPlans();
  }, [fetchTokenPlans]);

  // Fetch unpaid invoices when subscription ID changes
  useEffect(() => {
    if (subscriptionId) {
      fetchUnpaidInvoices();
    }
  }, [subscriptionId, fetchUnpaidInvoices]);

  const calculateResumeTotalAmount = () => {
    // 1. Try to find in plansData (most accurate current price)
    const currentPlan = plansData?.find((p) => p.plan_name === selectedPlan);
    if (currentPlan) {
      return parseFloat(currentPlan.plan_amount) * numLocations;
    }

    // 2. Fallback to the amount already stored in the store record (fetched from DB)
    if (planAmount) {
      return parseFloat(planAmount) * numLocations;
    }

    return 0;
  };

  const handleResumeActivation = async (paymentTokenData) => {
    setIsResuming(true);
    setResumeError(null);

    const messages = [
      "Securing your payment details...",
      "Activating your subscription...",
      "Finalizing setup...",
      "Generating your invoice..."
    ];
    let msgIndex = 0;
    setResumeMessage(messages[0]);

    const msgInterval = setInterval(() => {
      msgIndex++;
      if (msgIndex < messages.length) {
        setResumeMessage(messages[msgIndex]);
      }
    }, 3000);

    // Fix 1e: Branch on gateway status — upgrade ARB failures use the lightweight retry
    // endpoint that ONLY retries ARB. First-time activation failures use activate-pending.
    const isUpgradeArbFailure = gatewayStatus === 'upgrade_charge_succeeded_subscription_failed';

    try {
      let result;

      if (isUpgradeArbFailure) {
        // Upgrade ARB retry path: no payment token needed, card already vaulted.
        // This endpoint ONLY retries ARB — no charge, no new subscription row, no credits.
        setResumeMessage("Retrying recurring billing setup...");
        const response = await fetch(`${config.API_BASE_V2_URL}/subscriptions/retry-upgrade-arb`, {
          method: "POST",
          headers: config.getHeaders(),
          body: JSON.stringify({
            store_id: store_id,
            client_id: CLIENT_ID,
          }),
        });
        result = await response.json();
      } else {
        // First-time activation path: may need a payment token for vaulting.
        const payload = {
          client_id: CLIENT_ID,
          payment_token: paymentTokenData ? {
            data_descriptor: paymentTokenData.dataDescriptor,
            data_value: paymentTokenData.dataValue,
          } : null,
          number_of_locations: numLocations,
          plan_code: plansData?.find(p => p.plan_name === selectedPlan)?.plan_code,
          free_trial: false,
        };
        const response = await fetch(`${config.API_BASE_URL}/client/store/${store_id}/activate-pending`, {
          method: "POST",
          headers: config.getHeaders(),
          body: JSON.stringify(payload),
        });
        result = await response.json();
      }

      if (!result.success) {
        throw new Error(result.error?.details || result.error || result.message || "Activation failed");
      }

      clearInterval(msgInterval);

      const invUrl = result.data?.invoice_url || result.invoice_url;

      if (invUrl) {
        setResumeInvoiceUrl(invUrl);
        setResumeMessage(isUpgradeArbFailure ? "Recurring billing activated successfully!" : "Store activated successfully!");
        showSnackbar(isUpgradeArbFailure ? "Recurring billing activated!" : "Store activated successfully!", "success");
        setIsSuccess(true);
      } else {
        setResumeMessage("Finalizing setup...");
        setTimeout(() => {
          setIsSuccess(true);
        }, 2000);
      }

      // Refresh data
      await fetchStoreData();

    } catch (error) {
      clearInterval(msgInterval);
      console.error("Activation error:", error);
      setResumeError(error.message);
    } finally {
      setIsResuming(false);
    }
  };

  const handleCancelSubscription = async () => {
    if (!subscriptionId) return;

    if (!window.confirm("Are you sure you want to cancel your subscription? You will still have access to your credits until the end of your billing cycle, and you won't be charged again.")) {
      return;
    }

    try {
      setIsCancelling(true);
      const res = await fetch(`${config.API_BASE_V2_URL}/subscriptions/${subscriptionId}/cancel-at-period-end`, {
        method: "POST",
        headers: config.getHeaders()
      });
      const json = await res.json();

      if (json.success) {
        showSnackbar(json.message, "success");
        setCancelAtPeriodEnd(true);
        await fetchStoreData();
      } else {
        showSnackbar(json.detail || "Failed to cancel subscription", "error");
      }
    } catch (err) {
      console.error("Cancellation error:", err);
      showSnackbar("Failed to cancel subscription. Please try again.", "error");
    } finally {
      setIsCancelling(false);
    }
  };





  // ------------------------------------------------------
  // Main Render
  // ------------------------------------------------------
  if (loading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Card sx={{ boxShadow: "none", mb: "25px", p: 3 }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight="700">
          Edit Store
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/store-management")}
        >
          Back
        </Button>
      </Box>

      {/* Main Tabs */}
      <Tabs
        value={activeTab}
        onChange={(_, v) => setActiveTab(v)}
      >
        <Tab label="Store Info" />
        <Tab label="Subscription" />
        <Tab label="Chatbot Settings" disabled={!isActiveStore} />
        <Tab label="Branding" disabled={!isActiveStore} sx={{ display: 'none' }} />
      </Tabs>

      {/* -------------------------------------------------- */}
      {/* STORE INFO TAB */}
      {/* -------------------------------------------------- */}
      <CustomTabPanel value={activeTab} index={0}>
        <StoreInfo
          storeName={storeName}
          setStoreName={(v) => {
            setStoreName(v);
            setStoreInfoChanged(true);
          }}
          storeTypes={storeTypes}
          setStoreTypes={(v) => {
            setStoreTypes(v);
            setStoreInfoChanged(true);
          }}
          zipCodes={zipCodes}
          setZipCodes={(v) => {
            setZipCodes(v);
            setStoreInfoChanged(true);
          }}
          numLocations={numLocations}
          setNumLocations={(v) => {
            setNumLocations(v);
            setStoreInfoChanged(true);
          }}
          contactName={contactName}
          setContactName={(v) => {
            setContactName(v);
            setStoreInfoChanged(true);
          }}
          contactEmail={contactEmail}
          setContactEmail={(v) => {
            setContactEmail(v);
            setStoreInfoChanged(true);
          }}
          storeUrl={storeUrl}
          setStoreUrl={(v) => {
            setStoreUrl(v);
            setStoreInfoChanged(true);
          }}
          isEdit={true}
        />

        <Stack direction="row" justifyContent="space-between" mt={2}>
          <Button
            variant="contained"
            onClick={handleSaveStoreInfo}
            disabled={!storeInfoChanged}
          >
            Save Changes
          </Button>

          <Button variant="contained" onClick={() => setActiveTab(1)}>
            Next
          </Button>
        </Stack>
      </CustomTabPanel>

      {/* -------------------------------------------------- */}
      {/* SUBSCRIPTION TAB */}
      {/* -------------------------------------------------- */}
      <CustomTabPanel value={activeTab} index={1}>
        {/* Inner Tabs */}
        {/* <Tabs
          value={subTab}
          onChange={(_, v) => setSubTab(v)}
          sx={{ mb: 2 }}
        >
          <Tab label="Regular Subscription" />
          <Tab label="One-Time Token Purchase" />
        </Tabs> */}
        <Tabs
          value={subTab}
          onChange={(_, v) => setSubTab(v)}
          centered
          sx={{
            mb: 3,
            borderBottom: "1px solid #e2e8f0",
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab
            label="Regular Subscription"
            sx={{
              textTransform: "none",
              fontSize: "15px",
              fontWeight: subTab === 0 ? 700 : 500,
              color: subTab === 0 ? "#0f172a" : "#64748b",
              paddingY: 1.5,
              minWidth: 200,

              borderBottom: subTab === 0 ? "3px solid #3b82f6" : "3px solid transparent",
              backgroundColor: subTab === 0 ? "rgba(59,130,246,0.06)" : "transparent",

              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",

              transition: "0.2s ease",
              "&:hover": {
                backgroundColor: "rgba(59,130,246,0.08)",
              },
            }}
          />

          <Tab
            label="One-Time Token Purchase"
            sx={{
              textTransform: "none",
              fontSize: "15px",
              fontWeight: subTab === 1 ? 700 : 500,
              color: subTab === 1 ? "#0f172a" : "#64748b",
              paddingY: 1.5,
              minWidth: 220,

              borderBottom: subTab === 1 ? "3px solid #3b82f6" : "3px solid transparent",
              backgroundColor: subTab === 1 ? "rgba(59,130,246,0.06)" : "transparent",

              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",

              transition: "0.2s ease",
              "&:hover": {
                backgroundColor: "rgba(59,130,246,0.08)",
              },
            }}
          />
        </Tabs>


        {/* Regular Subscription */}
        {subTab === 0 && (
          <Box>
            {hasInterruptedPlanChange && (
              <Box
                sx={{
                  p: 3,
                  mb: 3,
                  backgroundColor: "#fffbeb", // Amber 50
                  borderRadius: "8px",
                  border: "1px solid #fcd34d", // Amber 300
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                  <Box>
                    <Typography variant="h6" fontWeight="700" color="#b45309" mb={0.5}>
                      {interruptedType === 'upgrade' ? 'Finish Your Upgrade' : 'Finish Your Downgrade'}
                    </Typography>
                    <Typography variant="body2" color="#92400e">
                      It looks like you previously started a plan change to <strong>{interruptedTargetPlan}</strong> that wasn't fully finalized. 
                      Please finish your setup below. You will not be charged again for this action.
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={handleResumePlanChange}
                    disabled={isResumingPlan}
                    sx={{ fontWeight: "bold", minWidth: 160 }}
                  >
                    {isResumingPlan ? "Resuming..." : `Finish ${interruptedType === 'upgrade' ? 'Upgrade' : 'Downgrade'}`}
                  </Button>
                </Box>
              </Box>
            )}

            <Box sx={{ 
              opacity: hasInterruptedPlanChange ? 0.6 : 1, 
              pointerEvents: hasInterruptedPlanChange ? "none" : "auto",
              filter: hasInterruptedPlanChange ? "grayscale(50%)" : "none"
            }}>
              <SubscriptionTypeClean
                numLocations={numLocations}
                selectedPlan={selectedPlan}
                setSelectedPlanExternal={handlePlanSelect}
                plansData={plansData}
                isEdit={true}
                onEditLocations={() => setShowManageLocationsModal(true)}
                currentPlanData={currentPlanData}
                subscriptionStatus={subscriptionStatus}
                nextDueDate={nextDueDate}
                unpaidInvoice={unpaidInvoice}
                onPayPendingInvoice={handlePayPendingInvoice}
                subscriptionCreditsConsumed={subscriptionCreditsConsumed}
                topupCreditsGranted={topupCreditsGranted}
                topupCreditsConsumed={topupCreditsConsumed}
                cancelAtPeriodEnd={cancelAtPeriodEnd}
                onCancelSubscription={handleCancelSubscription}
                isCancelling={isCancelling}
              />
            </Box>
          </Box>
        )}

        {/* ONE-TIME TOKEN PURCHASE MODE */}
        {subTab === 1 && (
          <div style={{ display: "flex", gap: "20px" }}>
            {/* LEFT = token packs */}
            <Grid item xs={12} md={6} width={"50%"}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                Select Credits Pack
              </Typography>

              {tokenPlans.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  Loading available top-up packs...
                </Typography>
              ) : (
                tokenPlans.map((plan) => (
                  <Card
                    key={plan.plan_code}
                    onClick={() => setSelectedTokenPack(plan)}
                    sx={{
                      p: 2,
                      mb: 2,
                      cursor: "pointer",
                      border:
                        selectedTokenPack?.plan_code === plan.plan_code
                          ? "2px solid #1976d2"
                          : "1px solid #ccc",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography fontWeight={700}>
                      {plan.plan_name}
                    </Typography>

                    <Typography
                      color="text.secondary"
                      sx={{ mt: 0.5 }}
                    >
                      {plan.description}
                    </Typography>

                    <Typography sx={{ mt: 1 }}>
                      <strong>
                        {plan.credits.toLocaleString()}
                      </strong>{" "}
                      credits
                    </Typography>

                    <Typography fontWeight={700} sx={{ mt: 1 }}>
                      ${plan.amount}
                    </Typography>
                  </Card>
                ))
              )}
            </Grid>

            {/* RIGHT = summary box */}
            <Grid item xs={12} md={6} width={"50%"}>
              <SubscriptionTypeClean
                isTokenMode={true}
                selectedTokenPack={
                  selectedTokenPack
                    ? {
                      title: selectedTokenPack.plan_name,
                      tokens: selectedTokenPack.credits,
                      amount: selectedTokenPack.amount,
                    }
                    : null
                }
                plansData={[]}
                numLocations={numLocations}
                isEdit={true}
              />
            </Grid>
          </div>
        )}

        <Stack direction="row" justifyContent="space-between" mt={2}>
          <Button variant="outlined" onClick={() => setActiveTab(0)}>
            Previous
          </Button>

          <Button
            variant="contained"
            onClick={
              subTab === 0 ? () => setActiveTab(2) : handleTokenPurchase
            }
            disabled={subTab === 1 && !selectedTokenPack}
          >
            {subTab === 0 ? "Next" : "Buy Tokens"}
          </Button>
        </Stack>
      </CustomTabPanel>

      {/* -------------------------------------------------- */}
      {/* CHATBOT TAB */}
      {/* -------------------------------------------------- */}
      <CustomTabPanel value={activeTab} index={2}>
        <ChatbotSettings
          isEditable={isPremiumOrAbove}
          chatbotName={chatbotName}
          setChatbotName={(v) => {
            setChatbotName(v);
            setChatbotChanged(true);
          }}
          welcomeMessage={chatbotWelcomeMessage}
          setWelcomeMessage={(v) => {
            setChatbotWelcomeMessage(v);
            setChatbotChanged(true);
          }}
          disclaimerText={chatbotDisclaimer}
          setDisclaimerText={(v) => {
            setChatbotDisclaimer(v);
            setChatbotChanged(true);
          }}
          logoUrl={brandingLogoUrl}
          setLogoUrl={(v) => {
            setBrandingLogoUrl(v);
            setChatbotChanged(true);
          }}
        />

        <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2}>
          <Button variant="outlined" onClick={() => setActiveTab(1)}>
            Previous
          </Button>
          <Stack direction="row" gap={2}>
            <Button
              variant="contained"
              disabled={!chatbotChanged || !isPremiumOrAbove}
              onClick={handleSaveChatbot}
            >
              Save Changes
            </Button>
          </Stack>
        </Stack>
      </CustomTabPanel>

      {/* -------------------------------------------------- */}
      {/* BRANDING TAB */}
      {/* -------------------------------------------------- */}
      <CustomTabPanel value={activeTab} index={3}>
        <BrandingAppearance
          isEditable={isPremiumOrAbove}
          themeColor={brandingThemeColor}
          setThemeColor={(v) => {
            setBrandingThemeColor(v);
            setBrandingChanged(true);
          }}
          fontStyle={brandingFontStyle}
          setFontStyle={(v) => {
            setBrandingFontStyle(v);
            setBrandingChanged(true);
          }}
          logoUrl={brandingLogoUrl}
          setLogoUrl={(v) => {
            setBrandingLogoUrl(v);
            setBrandingChanged(true);
          }}
        />

        <Stack direction="row" justifyContent="space-between" mt={2}>
          <Button variant="outlined" onClick={() => setActiveTab(2)}>
            Previous
          </Button>
          <Stack direction="row" gap={2}>
            <Button
              variant="contained"
              disabled={!brandingChanged || !isPremiumOrAbove}
              onClick={handleSaveBranding}
            >
              Save Changes
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate("/store-management")}
            >
              Done
            </Button>
          </Stack>
        </Stack>
      </CustomTabPanel>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() =>
          setSnackbar((prev) => ({ ...prev, open: false }))
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() =>
            setSnackbar((prev) => ({ ...prev, open: false }))
          }
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Modals */}
      <ManageSeatsModal
        open={showManageSeatsModal}
        onClose={() => {
          setShowManageSeatsModal(false);
          setPendingQuantity(null);
        }}
        currentPlan={currentPlanData}
        currentQuantity={numLocations}
        onSave={() => { }}
        subscriptionId={subscriptionId}
      />

      <ManageLocationsModal
        open={showManageLocationsModal}
        onClose={() => setShowManageLocationsModal(false)}
        currentPlan={currentPlanData}
        currentLocations={storeTypes.map((type, index) => ({
          store_type: type,
          zip_code: zipCodes[index] || "",
        }))}
        onSave={() => {
          setShowManageLocationsModal(false);
          fetchStoreData(); // Refresh data after save
        }}
        storeId={store_id}
        subscriptionId={subscriptionId}
      />

      <PlanChangeModal
        open={showPlanChangeModal}
        onClose={() => {
          setShowPlanChangeModal(false);
          setSelectedPlan(previousPlan); // revert if cancelled/closed
        }}
        currentPlan={currentPlanData}
        newPlan={pendingPlan}
        onConfirm={handleProrationConfirm}
        subscriptionId={subscriptionId}
        storeId={store_id}
        nextDueDate={nextDueDate}
        subscriptionCreditsGranted={subscriptionCreditsGranted}
        subscriptionCreditsConsumed={subscriptionCreditsConsumed}
        topupCreditsGranted={topupCreditsGranted}
        topupCreditsConsumed={topupCreditsConsumed}
        isProcessing={isPlanChangeProcessing}
        isSuccess={isPlanChangeSuccess}
        invoiceUrl={planChangeInvoiceUrl}
        successAmountCents={planChangeAmount * 100}
        processingMessage={planChangeMessage}
        errorMessage={planChangeError}
        numLocations={numLocations}
      />

      <AddLocationDetailsModal
        open={showAddLocationModal}
        onClose={() => {
          setShowAddLocationModal(false);
          setPendingQuantity(null);
        }}
        onSave={() => { }}
        numberOfNewLocations={
          pendingQuantity ? pendingQuantity - numLocations : 0
        }
        existingStoreTypes={storeTypes}
        existingZipCodes={zipCodes}
      />

      {/* Resume Activation Modal */}
      <AcceptJsCardModal
        open={showResumeModal}
        onClose={() => {
          if (!isResuming) {
            setShowResumeModal(false);
            // If they close without completing, redirect or show warning?
            // User said: "that closure should redirect them to the store management instead of the create profile."
            navigate("/store-management");
            setIsSuccess(false);
          }
        }}
        planSummary={{
          name: selectedPlan,
          // For upgrade ARB failures: the user already paid the proration amount. The ARB retry
          // doesn't charge them. Show $0.00 so the modal header renders "Previously Paid"
          // and the recovery body doesn't show a misleading full plan price.
          price: gatewayStatus === 'upgrade_charge_succeeded_subscription_failed'
            ? '$0.00'
            : `$${calculateResumeTotalAmount().toFixed(2)}`,
          description: gatewayStatus === 'upgrade_charge_succeeded_subscription_failed'
            ? [`Upgrade billing setup for ${storeName}`]
            : [`Pending activation for ${storeName}`]
        }}
        enableFreeTrial={false}
        isProcessing={isResuming}
        isSuccess={isSuccess}
        isCharged={gatewayStatus === 'charge_succeeded_subscription_failed' || gatewayStatus === 'upgrade_charge_succeeded_subscription_failed'}
        successUrl={resumeInvoiceUrl}
        processingMessage={resumeMessage}
        errorMessage={resumeError}
        onSuccessClose={() => {
          setShowResumeModal(false);
        }}
        onSuccess={(opaqueData) => {
          handleResumeActivation(opaqueData);
        }}
      />

      <TokenPurchaseModal
        open={showTokenPurchaseModal}
        onClose={() => setShowTokenPurchaseModal(false)}
        onConfirm={handleConfirmTokenPurchase}
        selectedPack={selectedTokenPack}
        cardInfo={cardInfo}
        isProcessing={isTokenProcessing}
        isSuccess={tokenSuccess}
        errorMessage={tokenError}
        creditsGranted={tokenCreditsGranted}
        invoiceUrl={tokenPurchaseInvoiceUrl}
      />
    </Card>
  );
};

export default EditStore;